import React from 'react';
import { format } from 'date-fns';
import { Grid } from '@material-ui/core';
import i18n from 'i18next';
import Currency from '../../components/Currency';
import { DEFAULT_CURRENCY } from '../../config';
import { efesError } from '../../theme';
import { COUNTRIES } from '../../constants';
import { isArmenianLanguage } from '../langHelpers';

export const bindContractSummary = (
  totalDiscount, totalPrice, t, isFetchingPrice,
) => [
  {
    label: t('contract.summaryFields.roadCareAssistance'),
    value: (
      <Grid container justifyContent="flex-end">
        <div>
          <Currency
            value={totalPrice}
            withSymbol
            currency={DEFAULT_CURRENCY}
            isFetching={isFetchingPrice}
          />
        </div>
      </Grid>
    ),
  },
  {
    label: t('contract.summaryFields.discount'),
    value: (
      <Grid container justifyContent="flex-end">
        <div style={{ color: efesError }}>
          <Currency
            value={totalDiscount}
            withSymbol
            currency={DEFAULT_CURRENCY}
            isFetching={isFetchingPrice}
          />
        </div>
      </Grid>
    ),
  },
];

export const bindSummaryContractData = (
  t,
  range,
) => [
  {
    label: t('contract.summaryFields.type'),
    value: (
      <div style={{ fontSize: 12 }}>
        {t('roadCareCalculator.transportInsurance')}
      </div>
    ),
  },
  {
    label: t('contract.summaryFields.startDate'),
    value: (
    // eslint-disable-next-line no-restricted-globals
      <div>{range.start && !isNaN(range.start) ? format(range.start, 'dd/MM/yyyy') : '-'}</div>
    ),
  },
  {
    label: t('contract.summaryFields.endDate'),
    // eslint-disable-next-line no-restricted-globals
    value: <div>{range.end && !isNaN(range.end) ? format(range.end, 'dd/MM/yyyy') : '-'}</div>,
  },
  {
    label: t('contract.summaryFields.region'),
    value: (
      <Grid container justifyContent="flex-end">
        <div>
          {isArmenianLanguage(i18n.language) ? COUNTRIES.ARM.nameHY : COUNTRIES.ARM.nameEN}
        </div>
      </Grid>
    ),
  },
];

export const bindRoadCareVehicleFormData = (data) => ({
  color: data.vehicleColor ?? '',
  manufacturerName: { id: 0, label: data.modelName },
  modelName: { id: 0, label: data.vehicleModel },
  transportUseType: {
    ...data.vehicleType,
    label: data.vehicleType?.name,
  },
  horsePower: String(data.vehicleEnginePower),
  passport: data.certNum,
  releaseYear: { id: 0, label: data.released },
  vin: data.vehicleVinLastFour,
});
